import React, { useState } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Typography,
  Select,
  InputNumber,
  Divider,
  Space
} from 'antd';
import '../Common/Form.css';
import {
  renderAditionalExerciseFieldsOnSubunitLevel,
  renderAdditionalExerciseForm,
  renderAditionalVideoFieldsOnSubunitLevel,
  renderAdditionalVideoForm,
  renderAdditionalCertificateForm
} from './SubunitHelpers';

const { Text } = Typography;

const SubunitForm = ({
  initialValues,
  onSubmit,
  subunitType,
  status,
  type,
  setStatus
}) => {
  const [currentSubunitType, setCurrentSubunitType] = useState(
    subunitType
  );
  const [form] = Form.useForm();
  return (
    <div className="course-add-form">
      <Form
        labelCol={{ span: 10 }}
        onFinish={onSubmit}
        initialValues={initialValues}
        form={form}>
        <section>
          {!subunitType ? (
            <Form.Item
              label="Subunit Type"
              name="subunitType"
              rules={[
                { required: true, message: 'Please input Subunit Type!' }
              ]}>
              <Select
                onChange={(e) => {
                  setCurrentSubunitType(e);
                }}
                placeholder={'Select Subunit Type'}>
                <Select.Option value={'Video'}>Video</Select.Option>
                <Select.Option value={'Exercise'}>Exercise</Select.Option>
                <Select.Option value={'Certificate'}>
                  Certificate
                </Select.Option>
              </Select>
            </Form.Item>
          ) : (
            <Text>Chosen: {subunitType}</Text>
          )}

          {/* We're on Add state, no subunit Type given, we're adding new subunit */}
          <Form.Item
            label="Code"
            name="code"
            rules={[
              { required: true, message: 'Please input subunit code!' }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: 'Please subunit title!' }]}>
            <Input />
          </Form.Item>
          {!['Certificate', 'Video'].includes(currentSubunitType) ? (
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: false
                }
              ]}>
              <Input />
            </Form.Item>
          ) : null}
          <Form.Item
            label="Section Number"
            name="sectionNumber"
            rules={[
              {
                required: true,
                message: 'Please input subunit section number!'
              }
            ]}>
            <InputNumber min={0} />
          </Form.Item>
        </section>

        {/* If we are adding a new subunit, we'd  want asset-specific fields to show only on asset-selection
            And we display both asset-specific fields on subunit level and on asset level  */}
        {type === 'Add' ? (
          <>
            {currentSubunitType === 'Exercise' &&
              renderAditionalExerciseFieldsOnSubunitLevel()}
            {currentSubunitType === 'Exercise' &&
              renderAdditionalExerciseForm()}
            <Divider></Divider>

            {currentSubunitType === 'Video' &&
              renderAditionalVideoFieldsOnSubunitLevel()}
            <Divider></Divider>
            {currentSubunitType === 'Video' && renderAdditionalVideoForm()}

            {currentSubunitType === 'Certificate' &&
              renderAdditionalCertificateForm(form, setStatus, type)}
          </>
        ) : null}

        {/* If we are updating a subunit, we'd  want asset-specific fields that are on subunit level to appear, and not asset-specific on asset level fields  */}
        {type === 'Update' ? (
          <>
            <section>
              {currentSubunitType === 'Exercise' &&
                renderAditionalExerciseFieldsOnSubunitLevel()}
            </section>
            <section>
              {currentSubunitType === 'Video' &&
                renderAditionalVideoFieldsOnSubunitLevel()}
            </section>
          </>
        ) : null}

        {status.type === 'ERROR' ? (
          <Text type="danger">{status.message}</Text>
        ) : null}
        {status.type === 'SUCCESS' ? (
          <Text type="success">Successful!</Text>
        ) : null}
        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SubunitForm;
